import { STRINGS } from '../../constants';
import apiCaller from '../http';
import URLS from '../urls';

const beginVisit = async (visitId, setError, refreshVisitDetail, logoutHandler) => {
  const payload = { visit_id: visitId };
  await apiCaller
    .put(`${URLS.VISIT_BEGIN}${visitId}/`, {
      params: payload,
    })
    .then(() => {
      setError(null);
      refreshVisitDetail();
    })
    .catch((e) => {
      if (e.message === STRINGS.common.errorMissingCredentials) {
        logoutHandler();
      }
      if (e.message === STRINGS.common.error400Template) {
        setError(STRINGS.common.error400Text);
      }
    });
};

export default beginVisit;
